// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3nw8q","approved":"Status_approved__3YkPr","rejected":"Status_rejected__3upW6","expired":"Status_expired__1KrmI","label":"Status_label__35K9P"};